// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_e8-0";
export var actionModalContentContainer = "_e8-1";
export var createTagButton = "_e8-2";
export var footerContainer = "_e8-7";
export var fullWidthDivider = "_e8-3";
export var hasCreateTagButton = "_e8-4";
export var noCreateTagButton = "_e8-5";
export var tagsContainer = "_e8-6";
export var tagsModalContentContainer = "_e8-8";